



































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  props: {
    createCheck: {
      type: Function,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      regions: [ // TODO: Add human readable name
        'ALL', 'DF', 'AC', 'AL',
        'AM', 'BA', 'CE', 'ES',
        'MA', 'MT', 'MS', 'MG',
        'PA', 'PB', 'PR', 'PE',
        'PI', 'RJ', 'RN', 'RS',
        'RO', 'RR', 'SC', 'SP',
        'SE', 'TO', 'AP', 'GO'
      ],
      region: '',
      rg: '',
      firstNames: '',
      lastNames: '',
      phoneNumber: ''
    }
  },
  computed: {
    ...mapGetters('results', ['getChecksCounter'])
  },
  methods: {
    buildCheckInput (): Record<string, string> {
      return {
        region: this.region,
        state_id: this.rg,
        first_name: this.firstNames,
        last_name: this.lastNames,
        phone_number: this.phoneNumber
      }
    }
  }
})
